import { render, staticRenderFns } from "./navbarText.vue?vue&type=template&id=33368b73&"
import script from "./navbarText.vue?vue&type=script&lang=js&"
export * from "./navbarText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports